import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberSuffix',
    standalone: false
})
export class NumberSuffixPipe implements PipeTransform {
  transform(value?: number): string {
    if (!value) return '0';

    if (value < 1000) return value.toString();

    const suffixes = ['', 'K', 'M', 'B'];
    const tier = Math.floor(Math.log10(value) / 3);
    if (tier === 0) return value.toString();
    const suffix = suffixes[tier];
    const scale = Math.pow(10, tier * 3);
    const scaled = value / scale;

    return scaled.toFixed(2).replace(/\.00$/, '') + suffix;
  }
}
